interface ErrorMessageProps {
  error: string | undefined
}

export const ErrorMessage = ({ error }: ErrorMessageProps) => {
  if (!error) return null
  return <p className="text-sm text-ss-critical-200 mt-1">{error}</p>
}
